import { useEffect, useState } from 'react';
import { useSnack } from 'shared/ui/snack/snack.hook';
import { ICountry } from 'interfaces/ICountry';
import { fetchCountriesDropdown } from 'shared/api/countries';


const useCountries = (load: boolean = true) => {
  const { showError } = useSnack();
  const [list, setList] = useState<ICountry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!load)
      return;

    setLoading(true);
    fetchCountriesDropdown()
      .then(response => setList(response))
      .catch(error => showError('Ошибка загрузки списка стран', error))
      .finally(() => {
        setLoading(false);
      });
  }, [load]);

  return ({
    list: list,
    loading
  });
};

export default useCountries;
